document.addEventListener("DOMContentLoaded", function () {
  const sliderWrapper = document.querySelector(".carousel-slider-wrapper");
  const slides = document.querySelectorAll(".carousel-slide");
  let currentIndex = 0;
  const slideCount = slides.length;

  function moveSlider() {
    currentIndex = (currentIndex + 1) % slideCount;
    sliderWrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
  }

  // Auto-move every 5 seconds
  setInterval(moveSlider, 5000);
});
